import USER_TYPES from './types';
import {
	type IUser,
	type IMetadata,
	type IUserType,
	type IBulkUpoadSummary,
} from 'src/models';

interface State {
	users: IUser[];
	virtualizedUsers: IUser[];
	usersCourses: any[];
	user: IUser;
	type: IUserType;
	institutionId: number;
	page: number;
	pageSize: number;
	isLoading: boolean;
	isLoadingOne: boolean;
	metadata: IMetadata;
	isDownloadingLayout: boolean;
	isUploadingBulk: boolean;
	bulkUploadSummaryOpen: boolean;
	bulkUploadSummary: IBulkUpoadSummary;
	isDownloadingCertificates: boolean;
	certificates: {
		data: any[];
		page: number;
		pageSize: number;
		isLoading: boolean;
		metadata: IMetadata;
	};
}

const initialState: State = {
	users: [],
	virtualizedUsers: [],
	usersCourses: [],
	user: {},
	type: 'Admin',
	institutionId: 0,
	page: 1,
	pageSize: 50,
	isLoading: false,
	isLoadingOne: false,
	metadata: {
		totalPages: 0,
		totalResults: 0,
	},
	isDownloadingLayout: false,
	isUploadingBulk: false,
	bulkUploadSummaryOpen: false,
	bulkUploadSummary: {
		created: [],
		updated: [],
		total: 0,
	},
	isDownloadingCertificates: false,
	certificates: {
		data: [],
		page: 1,
		pageSize: 50,
		isLoading: false,
		metadata: {
			totalPages: 0,
			totalResults: 0,
		},
	},
};

const reducer = (state: State = initialState, action: any): State => {
	const { type, payload } = action;
	switch (type) {
		case USER_TYPES.GET_ALL: {
			return {
				...state,
				isLoading: true,
				page: payload.page || state.page,
				pageSize: payload.pageSize || state.pageSize,
			};
		}

		case USER_TYPES.GET_ALL_BY_INSTITUTION:
		case USER_TYPES.GET_BY_INSTITUTION: {
			return {
				...state,
				isLoading: true,
				institutionId: payload.institutionId || state.institutionId,
				page: payload.page || state.page,
				pageSize: payload.pageSize || state.pageSize,
			};
		}

		case USER_TYPES.SET_ALL: {
			return {
				...state,
				isLoading: false,
				users: payload.data,
				metadata: payload.metadata || state.metadata,
			};
		}

		case USER_TYPES.SET_ALL_BY_INSTITUTION: {
			return {
				...state,
				isLoading: false,
				virtualizedUsers: payload.data,
			};
		}

		case USER_TYPES.GET_ONE: {
			return {
				...state,
				isLoadingOne: true,
			};
		}

		case USER_TYPES.SET_ONE: {
			return {
				...state,
				isLoadingOne: false,
				user: payload.user,
			};
		}

		case USER_TYPES.SET: {
			return {
				...state,
				[payload.type]: payload.value,
			};
		}

		case USER_TYPES.INITIAL_STATE: {
			return initialState;
		}

		case USER_TYPES.BULK_UPLOAD: {
			return {
				...state,
				isUploadingBulk: true,
			};
		}

		case USER_TYPES.DOWNLOAD_LAYOUT: {
			return {
				...state,
				isDownloadingLayout: true,
			};
		}

		case USER_TYPES.SET_BULK_UPLOAD_SUMMARY: {
			return {
				...state,
				bulkUploadSummaryOpen: !state.bulkUploadSummaryOpen,
				bulkUploadSummary: payload.data,
			};
		}

		case USER_TYPES.GET_CERTIFICATES: {
			return {
				...state,
				certificates: {
					...state.certificates,
					isLoading: true,
					page: payload.page || state.certificates.page,
					pageSize: payload.pageSize || state.certificates.pageSize,
				},
			};
		}

		case USER_TYPES.SET_CERTIFICATES: {
			return {
				...state,
				certificates: {
					...state.certificates,
					data: payload.data,
					metadata: payload.metadata || state.certificates.metadata,
					isLoading: false,
					page: payload.page || state.certificates.page,
					pageSize: payload.pageSize || state.certificates.pageSize,
				},
			};
		}

		case USER_TYPES.DOWNLOAD_CERTIFICATES: {
			return {
				...state,
				isDownloadingCertificates: true,
			};
		}

		default:
			return state;
	}
};

export default reducer;
